import SegmentUtils from 'utils/segment';
import SpotUtils from 'utils/spot';
import getParkingType from '../utils/parking-type';

/* eslint-disable camelcase */
export default function({
    citySlug,
    pageType,
    isMonthly,
    spots,
    filters,
    sortBy,
}) {
    const {activeReservationType, activeAmenities, viaQuickFilter} = filters;
    const isEvent = pageType === 'event';
    const isAirport = pageType === 'airport';
    const parkingType = getParkingType({isMonthly, isAirport, isEvent});
    const allFilters = [
        ...activeAmenities,
        ...(activeReservationType !== 'all' ? [activeReservationType] : []),
    ];
    const filteredSpots = SpotUtils.sortByAttribute(
        SpotUtils.filter(spots, filters, isMonthly),
        sortBy
    );
    const properties = {
        city: citySlug,
        filters: allFilters.map(filter => {
            return {value: filter};
        }),
        parking_type: parkingType,
        products: filteredSpots.map(
            ({parking_spot_id, title, selectedRate}) => {
                return {
                    category: parkingType,
                    name: title,
                    price: selectedRate.price,
                    product_id: String(parking_spot_id),
                    quantity: 1,
                };
            }
        ),
        via_quick_filter: viaQuickFilter,
    };

    SegmentUtils.track({
        event: 'Product List Filtered',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 1,
                },
            },
        },
    });
}
